export const isValidImageSrc = (src?: string | null) => {
  if (!src) return;
  const isAbsoluteUrl = /^https?:\/\//i.test(src);
  const isRelativeUrl = src.startsWith('/');
  return isAbsoluteUrl || isRelativeUrl;
};
